import { render, staticRenderFns } from "./single-choice-prop.vue?vue&type=template&id=2a1bb2a0&scoped=true&"
import script from "./single-choice-prop.vue?vue&type=script&lang=js&"
export * from "./single-choice-prop.vue?vue&type=script&lang=js&"
import style0 from "./single-choice-prop.vue?vue&type=style&index=0&id=2a1bb2a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1bb2a0",
  null
  
)

component.options.__file = "single-choice-prop.vue"
export default component.exports